document.addEventListener('DOMContentLoaded', function() {
  document.querySelector('.js-searchSubmit').addEventListener('click', function (e) {
    document.querySelector('.js-animate-spin').classList.remove('hidden');
    document.querySelector('.js-searchSubmit').disabled = true;
    setTimeout(() => {
      document.querySelector('.js-animate-spin').classList.add('hidden');
      document.querySelector('.js-searchSubmit').disabled = false;
    }, 500);
  });
});